var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#FFD100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4456 9.27244C20.3597 9.10658 20.1884 9.00247 20.0016 9.00248H12.6256L14.4896 0.609828C14.5419 0.377595 14.4232 0.140687 14.2058 0.043554C13.9885 -0.0535785 13.7327 0.0160113 13.5946 0.209892L3.5946 14.2076C3.48375 14.3601 3.46809 14.5619 3.55408 14.7296C3.64007 14.8974 3.81309 15.0025 4.0016 15.0015H11.3776L9.5136 23.3902C9.46128 23.6224 9.57999 23.8593 9.79736 23.9564C10.0147 24.0536 10.2705 23.984 10.4086 23.7901L20.4086 9.79235C20.5175 9.6397 20.5318 9.43897 20.4456 9.27244Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashIcon);
export default __webpack_public_path__ + "static/media/flash-icon.de313c2ddd8d46b5d6ea1bd54c56bbeb.svg";
export { ForwardRef as ReactComponent };